export const GLYPHS_FETCHING_ERROR_PREFIX = 'Failed to fetch glyphs';
